import React from 'react';
import { withRouter } from 'react-router-dom';
import Header from 'components/Header';
import BackLink from 'components/BackLink';
import CancelGoButtons from 'components/CancelGoButtons';
import { Form, Icon } from 'semantic-ui-react';
import API from 'utils/api';

const UNIT_OPTIONS = [
  { key: 'g',     value: 'g',     text: 'g — gramos' },
  { key: 'kg',    value: 'kg',    text: 'kg — kilogramos' },
  { key: 'mg',    value: 'mg',    text: 'mg — miligramos' },
  { key: 'oz',    value: 'oz',    text: 'oz — onzas' },
  { key: 'lb',    value: 'lb',    text: 'lb — libras' },
  { key: 'ml',    value: 'ml',    text: 'ml — mililitros' },
  { key: 'cl',    value: 'cl',    text: 'cl — centilitros' },
  { key: 'dl',    value: 'dl',    text: 'dl — decilitros' },
  { key: 'l',     value: 'l',     text: 'L — litros' },
  { key: 'tsp',   value: 'tsp',   text: 'tsp — cucharadita' },
  { key: 'tbsp',  value: 'tbsp',  text: 'tbsp — cucharada' },
  { key: 'cup',   value: 'cup',   text: 'taza' },
  { key: 'pza',   value: 'pza',   text: 'pza — pieza' },
  { key: 'pinch', value: 'pinch', text: 'pizca' },
  { key: 'bunch', value: 'bunch', text: 'manojo' },
  { key: 'slice', value: 'slice', text: 'rebanada' },
];

class MenuProductIngredientForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      submitting: false,
      error: null,
      product: null,
      productId: null,
      ingredients: [],
      ingredientInput: '',
      selectedIngredient: null,   // { id, name } when picked from suggestions
      showSuggestions: false,
      quantity: '',
      unit: '',
      valid: false
    };
  }

  componentDidMount() {
    const productId = parseInt(this.props.match.params.productId);
    this.setState({ productId }, this.loadData);
  }

  loadData = () => {
    Promise.all([
      API.getProduct(this.state.productId),
      API.getIngredients()
    ])
      .then(([productRes, ingredientsRes]) => {
        this.setState({
          product: productRes.data,
          ingredients: ingredientsRes.data,
          loading: false
        });
      })
      .catch((error) => {
        console.error(error);
        this.setState({ error: 'Error al cargar los datos', loading: false });
      });
  }

  getSuggestions = () => {
    const { ingredientInput, ingredients } = this.state;
    const query = ingredientInput.trim().toLowerCase();
    if (!query) return [];
    return ingredients.filter(i => i.name.toLowerCase().includes(query));
  }

  handleIngredientInput = (event) => {
    this.setState({
      ingredientInput: event.target.value,
      selectedIngredient: null,
      showSuggestions: true
    }, this.validate);
  }

  handleSelectSuggestion = (ingredient) => {
    this.setState({
      ingredientInput: ingredient.name,
      selectedIngredient: ingredient,
      showSuggestions: false
    }, this.validate);
  }

  handleIngredientBlur = () => {
    // Delay so a suggestion click registers before hiding the list
    setTimeout(() => this.setState({ showSuggestions: false }), 150);
  }

  handleQuantity = (event) => {
    this.setState({ quantity: event.target.value }, this.validate);
  }

  handleUnit = (event, { value }) => {
    this.setState({ unit: value }, this.validate);
  }

  validate = () => {
    const { ingredientInput, quantity, unit } = this.state;
    const valid =
      ingredientInput.trim() !== '' &&
      unit !== '' &&
      quantity !== '' &&
      parseFloat(quantity) > 0;
    this.setState({ valid });
  }

  handleSubmit = () => {
    if (!this.state.valid) return;

    this.setState({ submitting: true, error: null });

    const { productId, selectedIngredient, ingredientInput, quantity, unit } = this.state;

    const saveProductIngredient = (resolvedIngredientId) => {
      API.createProductIngredient(productId, {
        ingredient_id: resolvedIngredientId,
        quantity: parseFloat(quantity),
        unit
      })
        .then(() => {
          this.props.history.push(`/menu/products/${productId}/ingredients`);
        })
        .catch((error) => {
          console.error(error);
          this.setState({ error: 'Error al guardar el ingrediente', submitting: false });
        });
    };

    if (selectedIngredient) {
      saveProductIngredient(selectedIngredient.id);
    } else {
      API.createIngredient({ name: ingredientInput.trim() })
        .then((response) => {
          saveProductIngredient(response.data.id);
        })
        .catch((error) => {
          console.error(error);
          this.setState({ error: 'Error al crear el ingrediente', submitting: false });
        });
    }
  }

  render() {
    const {
      ingredientInput, selectedIngredient, showSuggestions,
      quantity, unit, valid, submitting, loading, error, product, productId
    } = this.state;

    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: '2em' }}>
          <Icon loading name='spinner' size='large' />
          <p style={{ marginTop: '1em', color: '#666' }}>Cargando...</p>
        </div>
      );
    }

    const suggestions = this.getSuggestions();
    const isExactMatch = selectedIngredient &&
      selectedIngredient.name.toLowerCase() === ingredientInput.trim().toLowerCase();

    return (
      <div>
        <BackLink onClick={() => this.props.history.push(`/menu/products/${productId}/ingredients`)} />
        <Header text={product ? `${product.name}: Agregar ingrediente` : 'Agregar ingrediente'} />

        {error && (
          <div style={{
            color: '#db2828',
            margin: '1.5em 0',
            padding: '12px',
            backgroundColor: '#fff6f6',
            borderRadius: '4px',
            fontSize: '1.1em'
          }}>
            {error}
          </div>
        )}

        <Form as="div" style={{ marginTop: '1.5em' }}>
          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              INGREDIENTE
            </label>
            <div style={{ position: 'relative' }}>
              <input
                placeholder="Ej. Tomates"
                value={ingredientInput}
                onChange={this.handleIngredientInput}
                onBlur={this.handleIngredientBlur}
                onFocus={() => this.setState({ showSuggestions: true })}
                style={{
                  fontSize: '1.2em',
                  padding: '12px',
                  width: '100%',
                  borderRadius: isExactMatch || (!showSuggestions || suggestions.length === 0) ? '4px' : '4px 4px 0 0',
                  border: '1px solid rgba(34,36,38,.15)',
                  boxSizing: 'border-box'
                }}
              />
              {showSuggestions && suggestions.length > 0 && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  background: '#fff',
                  border: '1px solid rgba(34,36,38,.15)',
                  borderTop: 'none',
                  borderRadius: '0 0 4px 4px',
                  zIndex: 100,
                  boxShadow: '0 2px 6px rgba(0,0,0,0.1)'
                }}>
                  {suggestions.map(ingredient => (
                    <div
                      key={ingredient.id}
                      onMouseDown={() => this.handleSelectSuggestion(ingredient)}
                      style={{
                        padding: '10px 12px',
                        fontSize: '1.1em',
                        cursor: 'pointer',
                        borderBottom: '1px solid #f5f5f5'
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = '#f8f8f8'}
                      onMouseLeave={e => e.currentTarget.style.background = '#fff'}
                    >
                      {ingredient.name}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {ingredientInput.trim() !== '' && !isExactMatch && (
              <div style={{ marginTop: '6px', fontSize: '0.9em', color: '#999' }}>
                Se creará un nuevo ingrediente: <strong>{ingredientInput.trim()}</strong>
              </div>
            )}
          </Form.Field>

          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              CANTIDAD
            </label>
            <input
              type="number"
              min="0"
              step="any"
              placeholder="0"
              value={quantity}
              onChange={this.handleQuantity}
              style={{
                fontSize: '1.2em',
                padding: '12px',
                width: '100%',
                borderRadius: '4px',
                border: '1px solid rgba(34,36,38,.15)'
              }}
            />
          </Form.Field>

          <Form.Field style={{ marginBottom: '1.5em' }}>
            <label style={{ fontSize: '1.1em', color: '#666', marginBottom: '8px', display: 'block' }}>
              UNIDAD
            </label>
            <Form.Select
              fluid
              options={UNIT_OPTIONS}
              placeholder="Selecciona una unidad"
              value={unit}
              onChange={this.handleUnit}
              style={{ fontSize: '1.2em' }}
            />
          </Form.Field>

          <CancelGoButtons
            cancelFn={() => this.props.history.push(`/menu/products/${productId}/ingredients`)}
            cancelText="cancelar"
            goText="guardar"
            goFn={this.handleSubmit}
            goEnabled={valid && !submitting}
            loading={submitting}
            style={{
              button: {
                height: '54px',
                fontSize: '1.1em',
                fontWeight: 'bold',
                boxShadow: 'none',
                borderRadius: '8px'
              }
            }}
          />
        </Form>
      </div>
    );
  }
}

export default withRouter(MenuProductIngredientForm);
